module.exports = __webpack_public_path__ + "static/media/01_tearsofhair.b8bafaa2.jpg";